import React from 'react';
import { PapiDeviation, RelatedBlock } from '@wix/da-papi-types';
import SidebarBlockWrapper from '../../../_partials/SidebarBlockWrapper';
import TopicBlock from './TopicBlock';
import s from './Topics.scss';

interface Props {
  block: RelatedBlock;
  deviation: PapiDeviation;
}

const Topics: React.FC<React.PropsWithChildren<Props>> = ({
  block,
  deviation: parentDeviation,
}) => {
  if (!block.topics?.length) {
    return null;
  }

  return (
    <SidebarBlockWrapper
      deviation={parentDeviation}
      block={block}
      headerClassName={s['header']}
    >
      <div>
        {block.topics?.map(
          ({ itemId, name, url, exampleDeviations }) =>
            name &&
            url &&
            exampleDeviations &&
            exampleDeviations.length > 0 && (
              <TopicBlock
                key={itemId}
                topicId={itemId}
                parentDeviation={parentDeviation}
                title={name}
                deviations={exampleDeviations}
                linkTo={url}
              />
            )
        )}
      </div>
    </SidebarBlockWrapper>
  );
};
Topics.displayName = 'Topics';

export default Topics;
